import React from 'react';
import {
  Nav,
  NavItem,
  NavLink,
} from 'reactstrap';
import { useIntl } from 'react-intl';

const IntegrationsIntegrationTabs = () => {
  const intl = useIntl();

  return (
    <Nav tabs className="settings-tabs">
      <NavItem>
        <NavLink
          className="active"
        >
          <span>{intl.formatMessage({ defaultMessage: 'Details' })}</span>
        </NavLink>
      </NavItem>
    </Nav>
  );
};

export default IntegrationsIntegrationTabs;
